export default "__VITE_ASSET__ohYWzT1r__"